import { Injectable } from '@angular/core';
import { TreeviewI18nDefault, TreeviewItem, TreeviewSelection } from '@ingenmaffen/ngx-treeview';

@Injectable()
export class DropdownTreeviewSelectI18n extends TreeviewI18nDefault {
  private internalSelectedItem: TreeviewItem;

  set selectedItem(value: TreeviewItem) {
    this.internalSelectedItem = value;
  }

  get selectedItem(): TreeviewItem {
    return this.internalSelectedItem;
  }

  getText(selection: TreeviewSelection): string {
    return this.internalSelectedItem ? this.internalSelectedItem.text : 'Please select';
  }
}
